import { useTranslation } from "react-i18next";
import { Icon } from "@/shared/ui";

type Props = {
  icon: (props: { className?: string }) => JSX.Element;
  iconName: string;
  status: boolean;
  levelFrom?: number;
  levelTo?: number;
  onClick?: () => void;
};

export default function ImprovementsItem({
  icon: IconComponent,
  iconName,
  status,
  levelFrom,
  levelTo,
  onClick,
}: Props) {
  const { t } = useTranslation("business");

  return (
    <button
      className="group relative flex flex-col justify-between h-[7.75rem] p-5 bg-dark-800 rounded-2xl hover:cursor-pointer"
      type="button"
      onClick={onClick}
    >
      <IconComponent className="size-4" />
      <p className="relative z-2 max-w-28 text-15 text-start font-bold pointer-events-none">
        {t(`business.improvements.list.${iconName}`)}
      </p>
      <div className="absolute top-0 left-0 size-full bg-gradient-to-br from-accent-solid/30 to-transparent rounded-2xl transition-all duration-200 ease-in-out opacity-0 hover:opacity-100" />
      {status && (!levelFrom || !levelTo) && (
        <div className="absolute right-0 top-0 flex items-center gap-1.5 h-8 rounded-bl-2xl rounded-tr-2xl pointer-events-none">
          <div className="flex items-center gap-1.5 w-full h-8 py-[0.6875rem] px-2.5 text-11 font-bold uppercase leading-none">
            <Icon
              category="home-menu"
              name="checked"
              className="relative z-1 w-3.5 h-2.5 bg-accent-solid"
            />{" "}
            {t("business.improvements.buyed")}
          </div>
          <span className="absolute top-0 left-0 size-full bg-gradient-to-r from-accent-solid/30 to-transparent rounded-bl-2xl rounded-tr-2xl" />
        </div>
      )}
      {typeof levelFrom === "number" && typeof levelTo === "number" && (
        <div className="absolute z-2 top-2.5 right-2.5 flex items-center gap-0.5 py-1 px-1.5 text-11 font-bold uppercase leading-none bg-accent-solid/20 rounded-[0.3125rem]">
          {levelFrom === levelTo ? (
            <span className="flex gap-0.5 text-accent-solid">
              <Icon
                category="home-menu"
                name="checked"
                className="relative z-1 w-3.5 h-2.5 bg-accent-solid"
              />
              {t("business.improvements.max")}.
            </span>
          ) : (
            <>
              <span className="text-accent-solid">{levelFrom}</span>/{levelTo}
            </>
          )}{" "}
          {t("business.improvements.lvl")}.
        </div>
      )}
    </button>
  );
}
